module.exports = __webpack_public_path__ + "img/splash-bg.a05b4e32.jpg";